import { get } from "services/actions";
import strapiImg from "utils/strapiImg";
import AppLayout from "components/AppLayout";
import DiferenciaisPage from "components/pages/Diferenciais";

export default function Diferencias({ appLayout, diferenciaisPage }) {
  return (
    <AppLayout data={appLayout}>
      <DiferenciaisPage data={diferenciaisPage} />
    </AppLayout>
  );
}

export async function getStaticProps() {
  const header = await get("cabecalho");
  const footer = await get("rodape");
  const data = await get("diferenciais");
  const receiveNews = await get("receba-novidades");

  // DADOS COMPONENTE: AppLayout
  const appLayout = {
    header: {
      logo: strapiImg(header.logo, "", true),
      menu: header.menu,
    },
    footer: {
      logo: strapiImg(footer.logo, "", true),
      redes: footer.redes_sociais.map(({ id, nome, link, icone }) => {
        icone = strapiImg(icone, "", true);
        return {
          id,
          nome,
          link,
          icone,
        };
      }),
      unidades: footer.unidades,
      submenus: footer.submenu,
      whatsappIcon: strapiImg(footer?.icone_whatsapp_rodape, "", true),
      openChatBot: footer?.habilitar_chatbot
    },
  };

  // DADOS COMPONENT DiferenciaisPage
  const diferenciaisPage = {
    banner: {
      titulo: data.banner_topo.titulo,
      chamada: data.banner_topo.chamada,
      imagem: strapiImg(data.banner_topo.banner, "", true),
    },
    secaoDiferenciaisFirstPart: {
      imagem: strapiImg(data.imagem_secao, "", true),
      diferenciais: data.icones.slice(0, 2).map((item) => {
        return {
          id: item.id,
          titulo: item.titulo,
          texto: item.texto,
          icone: strapiImg(item.icone, "", true),
        };
      }),
    },
    secaoDiferenciasSecondPart: {
      diferenciais: data.icones.slice(2).map((item) => {
        return {
          id: item.id,
          titulo: item.titulo,
          texto: item.texto,
          icone: strapiImg(item.icone, "", true),
        };
      }),
    },
    secaoRecebaNovidades: {
      imagem: strapiImg(receiveNews.background_imagem, "", true),
      email: receiveNews.email_de_envio,
    },
  };

  return {
    props: {
      appLayout,
      diferenciaisPage,
    },
    revalidate: 60,
  };
}
